import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

export const INITIAL_STATE = {
  isFetching: true,
  headlines: [],
  error: null,
}

export const INITIALIZE = 'headlines/INITIALIZE'
export const FETCH = 'headlines/FETCH'
export const REFRESH = 'headlines/REFRESH'
export const RECEIVED = 'headlines/RECEIVED'
export const ERROR = 'headlines/ERROR'
export const CLEAN = 'headlines/CLEAN'

// initialize :: (Integer, Boolean) -> Action
export const initialize = (categoryId, autoRefresh = false) => ({
  type: INITIALIZE,
  categoryId,
  autoRefresh,
})

// fetch :: Integer -> Action
export const fetch = categoryId => ({
  type: FETCH,
  categoryId,
})

// refresh :: Integer -> Action
export const refresh = categoryId => ({
  type: REFRESH,
  categoryId,
})

// received :: [object] -> Action
export const received = headlines => ({
  type: RECEIVED,
  headlines,
})

// error :: Error -> Action
export const error = error => ({
  type: ERROR,
  error,
})

// clean :: () -> Action
export const clean = always({ type: CLEAN })

export default createReducer(INITIAL_STATE, {
  [FETCH]: state => ({
    ...state,
    isFetching: true,
    error: null,
  }),
  [REFRESH]: state => ({
    ...state,
    error: null,
  }),
  [RECEIVED]: (state, { headlines }) => ({
    ...state,
    isFetching: false,
    error: null,
    headlines,
  }),
  [ERROR]: (state, { error }) => ({
    ...state,
    isFetching: false,
    error,
  }),

  [CLEAN]: always(INITIAL_STATE),
})
